import React from 'react';
import { WowImage, ImageResizeOptions, IconButton, DotNavigation } from 'wix-ui-tpa/cssVars';
import { dataHooks } from '../../dataHooks';
import { ChevronLeft, ChevronRight, Close } from '@wix/wix-ui-icons-common/on-stage';
import { classes } from './SimpleGallery.st.css';
import { useGalleryLogic } from './Gallery.logic';
export const SimpleGallery = _ref => {
  let {
    images,
    currentImageIndex,
    dataHook,
    biFunctions,
    nextButtonAriaLabel,
    previousButtonAriaLabel,
    arrowsClassName,
    closeButtonProps
  } = _ref;
  const {
    currentImage,
    goToPrevious,
    goToNext,
    hasMultipleImages,
    activeIndex
  } = useGalleryLogic({
    images,
    currentImageIndex,
    biFunctions
  });
  return /*#__PURE__*/React.createElement("div", {
    className: `${classes.imageContainer}`,
    "data-active-index": activeIndex
  }, /*#__PURE__*/React.createElement(WowImage, {
    fluid: true,
    shouldUseLQIP: true,
    stretchImage: true,
    "data-hook": dataHooks.gallery.image(dataHook ?? ''),
    resize: ImageResizeOptions.cover,
    sourceHeight: currentImage == null ? void 0 : currentImage.sourceHeight,
    sourceWidth: currentImage == null ? void 0 : currentImage.sourceWidth,
    src: currentImage.src
  }), closeButtonProps && /*#__PURE__*/React.createElement(IconButton, {
    "aria-label": closeButtonProps.closeButtonAriaLabel,
    className: `${classes.closeButton} `,
    icon: /*#__PURE__*/React.createElement(Close, {
      size: 32
    }),
    onClick: closeButtonProps.closeButtonOnClick,
    "data-hook": closeButtonProps.closeButtonDataHook
  }), hasMultipleImages && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(IconButton, {
    "aria-label": previousButtonAriaLabel,
    className: `${classes.navigationArrow} ${classes.leftArrow} ${arrowsClassName}`,
    icon: /*#__PURE__*/React.createElement(ChevronLeft, {
      size: 32
    }),
    onClick: goToPrevious,
    "data-hook": dataHooks.gallery.previousButton(dataHook ?? '')
  }), /*#__PURE__*/React.createElement(IconButton, {
    "aria-label": nextButtonAriaLabel,
    className: `${classes.navigationArrow} ${classes.rightArrow} ${arrowsClassName}`,
    icon: /*#__PURE__*/React.createElement(ChevronRight, {
      size: 32
    }),
    onClick: goToNext,
    "data-hook": dataHooks.gallery.nextButton(dataHook ?? '')
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.dotNavigationWrapper
  }, /*#__PURE__*/React.createElement(DotNavigation, {
    currentIndex: activeIndex,
    length: images.length,
    "data-hook": dataHooks.gallery.dotNavigation(dataHook ?? '')
  }))));
};
//# sourceMappingURL=SimpleGallery.js.map